import { render, staticRenderFns } from "./MachineProfit.vue?vue&type=template&id=ed5b1d60"
import script from "./MachineProfit.vue?vue&type=script&lang=js"
export * from "./MachineProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports